import React, {Component} from 'react';
import Waypoint from "react-waypoint";
import Award from "../../Award/Award";
import TextBlock from "../../TextBlock/TextBlock";
import QuoteBlock from "../../QuoteBlock/QuoteBlock";
import bubbler from "../../../images/bubbler.png";
import building from "../../../images/building.png";
import cheese_nut1 from "../../../images/cheese_nut1.png";
import cheese_nut2 from "../../../images/cheese_nut2.png";
import cheese_nut3 from "../../../images/cheese_nut2.png";
import cheese_nut4 from "../../../images/cheese_nut3.png";
import cheese_nut5 from "../../../images/cheese_nut5.png";
import cheese_nut6 from "../../../images/cheese_nut6.png";
import cheese_nut7 from "../../../images/cheese_nut7.png";
import cheese_nut8 from "../../../images/cheese_nut8.png";
import chocolate1 from "../../../images/chocolate1.png";
import chocolate2 from "../../../images/chocolate2.png";
import construction from "../../../images/construction.png";
import factory from "../../../images/factory.png";
import gouda from "../../../images/gouda.png";
import hormel from "../../../images/hormel.png";
import iri from "../../../images/iri.png";
import journal from "../../../images/journal.png";
import nelson from "../../../images/nelson.png";
import packaging from "../../../images/packaging.png";
import pepper_jack from "../../../images/pepper_jack.png";
import pizzahut from "../../../images/pizzahut.png";
import wisconsin from "../../../images/wisconsin.png";
import rootsLogo from "../../../images/roots.svg";
import jacknbox from "../../../images/jack.png";
import culvers from "../../../images/culvers.png";
import fruitLogo from "../../../images/grapes.svg";
import "./Awards.css";

/**
 * Awards
 */
export default class Awards extends Component {

    /**
     * Default Props
     *
     * @type {{headerHeight: string}}
     */
    static defaultProps = {
        headerHeight: '112px',
        awardsRow: {
            award1: {
                text1: "THE MILWAUKEE JOURNAL SENTINEL'S",
                text2: " TOP WORKPLACES 2017"
            },
            award2: {
                text1: "IRI 2016 NEW PRODUCT",
                text2: "PACESETTER AWARD"
            },
            award3: {
                text1: "NIELSEN BREAKTHROUGH",
                text2: "INNOVATION AWARD"
            },
            award5: {
                text1: "HORMEL",
                text2: "SPIRIT OF EXCELLENCE AWARD"
            },
            award6: {
                text1: "PIZZA HUT",
                text2: "INNOVATION S.T.A.R AWARD"
            }
        },
        textBlocks: {
            footprint: {
                text1: "We marked 2017 with continued expansions to our facilities from our corporate headquarters in Plymouth to our production space in Hilbert.",
                text2: "Back in 1965, the Plymouth headquarters were contained primarily in a one-story building, an unassuming structure on County Road C. By 1977, the building had expanded to 17,149 square feet.",
                text3: "Over the past 52 years, our facilities, including the Plymouth HQ, mushroomed. We’ve added to the Plymouth site 28 times, with the latest 6,000 square-foot addition to the front of the facility in 2017.",
                text4: "This growth reflects the growth of our company, and our continued ability to help our workforce flourish. At Hilbert North in October, we began construction on a 40,000 square-foot expansion. When completed in late summer of 2018, we expect to add approximately 150 employees to the Sargento family."
            },
            waste: {
                text1: "When our Hilbert North facility was being designed in 2016, Sustainability Manager Alec Bartolai’s vision of creating a zero-waste facility was deliberately woven into the plans. He worked to include concrete strategies for recycling and reducing waste, and that effort has paid off. ",
                text2: "In fact, over the course of eight months in 2017, Hilbert North only generated about 20 total tons of landfill waste. To put that in perspective, without the strides taken by Alec in the design process and Hilbert North’s staff in the day-to-day, they would likely be generating that amount of trash every one to two weeks."
            }
        }
    };

    /**
     * Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.enterAwards = this.enterAwards.bind(this);
        this.leaveAwards = this.leaveAwards.bind(this);
    }

    /**
     * Enter awards
     *
     * @param event
     */
    enterAwards(event) {
        this.props.setHeader('OUR ROOTS', rootsLogo, 'Investing in the Sargento Family', true);
    }

    /**
     * Leave awards
     *
     * @param event
     */
    leaveAwards(event) {
        if (event.currentPosition === 'above') {
            this.props.setHeader('THE FRUITS OF OUR LABOR', fruitLogo, 'Awards, new products and more', true);
        }
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {

        const {awardsRow, headerHeight, textBlocks} = this.props;
        const {footprint, waste} = textBlocks;
        const {award1, award2, award3, award5, award6} = awardsRow;

        return (
            <div className="page_padding awards">
                <Waypoint onEnter={this.enterAwards}
                          onLeave={this.leaveAwards}
                          topOffset={headerHeight}/>

                <section className="layout">
                    <div className="column">
                        <TextBlock title="The Award Shelf"
                                   text="Every year, Sargento earns multiple awards for our innovation, community stewardship and workplace culture. We’re honored that 2017 was no exception!"/>
                    </div>
                    <div className="column bubbler">
                        <Award image={bubbler}
                               awardName="2017 BUBBLER AWARD"
                               infoObject={{
                                   text1: "Named one of the best places to work for young ",
                                   text2: "professionals in Wisconsin"
                               }}/>
                    </div>
                </section>

                <div className="layout">
                    <section className="awardsRow">
                        <Award image={journal}
                               awardNameObject={award1}
                               info="Selected for the eighth consecutive year"/>
                        <Award image={iri}
                               awardNameObject={award2}
                               infoObject={{
                                   text1: "Recognized for the launch of",
                                   text2: "Balanced Breaks® Snacks"
                               }}/>
                        <Award image={nelson}
                               awardNameObject={award3}
                               infoObject={{
                                   text1: "Balanced Breaks® Snacks named one of 18",
                                   text2: "(out of 4,500) winners"
                               }}/>
                        <Award image={wisconsin}
                               awardName="Wisconsin Manufacturer of the Year - Community Stewardship"
                               info="Recognized with special award for community service"/>
                        <Award image={hormel}
                               awardNameObject={award5}
                               info="Recognized for sixth consecutive year"/>
                        <Award image={pizzahut}
                               awardNameObject={award6}
                               info="Recognized for second consecutive year"/>

                        <div className="newAward">
                                   <span>
                                       <img alt=""
                                            src={jacknbox}/>
                                   </span>
                            <span>JACK IN THE BOX <br/> FOOD SAFETY & REGULATORY<br/>COMPLIANCE AWARD</span>
                            <span>Recognized for outstanding food safety and regulatory compliance</span>
                        </div>
                        <div className="newAward">
                                   <span>
                                   <img alt=""
                                        src={culvers}/>
                                   </span>
                            <span>CULVER'S INNOVATOR AWARD</span>
                            <span>Recognized for collaboration on new menu items and thought leadership</span>
                        </div>
                    </section>
                </div>

                <section className="layout">
                    <div className="column">
                        <TextBlock title="Introducing Sweet Balanced Breaks®"
                                   text="Following the massive success of our 2016 Balanced Breaks® cheese snacks launch, we saw an opportunity to give consumers even more ways to snack. In March, we released Sweet Balanced Breaks® cheese snacks, a new product combining the savory flavors of creamy, natural cheese with sweet ingredients like dried fruit and dark chocolate."/>
                    </div>
                    <div className="column chocolate">
                        <img alt=""
                             src={chocolate1}/>
                        <img alt=""
                             src={chocolate2}/>
                    </div>
                </section>

                <section>
                    <div className="packs">
                        <div>
                            <img alt=""
                                 src={cheese_nut7}/>
                        </div>
                        <div>
                            <img alt=""
                                 src={cheese_nut4}/>
                        </div>
                        <div>
                            <img alt=""
                                 src={cheese_nut8}/>
                        </div>
                        <div>
                            <img alt=""
                                 src={cheese_nut5}/>
                        </div>
                        <div>
                            <img alt=""
                                 src={cheese_nut3}/>
                        </div>
                        <div>
                            <img alt=""
                                 src={cheese_nut6}/>
                        </div>
                    </div>
                </section>


                <section className="layout">
                    <div className="column"/>
                    <div className="column">
                        <QuoteBlock quote="The Sweet Balanced Breaks® line lets people embrace their sweet side with the perfect balance of indulgence and real goodness.”"
                                    author="Ryan Hemsing"
                                    source="Director of Marketing, Consumer Products Division"/>
                    </div>
                </section>

                <section className="layout">
                    <div className="snacks">
                        <div className="snackbreak">
                            <TextBlock title="A Growing Snack Portfolio"
                                       text="We also added new flavors to our original Balanced Breaks® and Snack Bites® snack lines."/>
                            <div className="para_border">
                                <p>Balanced Breaks®</p>
                            </div>
                        </div>

                        <div className="snackbreak">
                            <img alt=""
                                 src={cheese_nut1}/>
                            <span>
                                   GOUDA NATURAL CHEESE WITH HONEY ROASTED PEANUTS AND
                                   DRIED CRANBERRIES
                                   </span>
                        </div>
                        <div className="snackbreak">
                            <img alt=""
                                 src={cheese_nut2}/>
                            <span>
                                   COLBY-JACK NATURAL CHEESE WITH SEA-SALTED PEANUTS AND BLUEBERRY
                                   JUICE-INFUSED DRIED CRANBERRIES
                                   </span>
                        </div>
                    </div>
                </section>

                <section className="layout">
                    <div className="snacks">
                        <div className="snackbreak">
                            <div className="para_border">
                                <p>Snack Bites®</p>
                            </div>
                        </div>
                        <div className="snackbreak">
                            <img alt=""
                                 src={gouda}/>
                            <span>SMOKEHOUSE GOUDA</span>
                            <span>
                                   Extra creamy and perfectly smoky, this Gouda brings big taste
                                   to every bite.
                                   </span>
                        </div>
                        <div className="snackbreak">
                            <img alt=""
                                 src={pepper_jack}/>
                            <span>COLBY-PEPPER JACK</span>
                            <span>
                                   Soft, mellow Colby cheese meets Monterey Jack mixed with
                                   habanero and jalapeño peppers to add a kick to this tasty little
                                   stick.
                                   </span>
                        </div>
                    </div>
                </section>


                <section className="layout">
                    <div className="column">
                        <TextBlock title="Waste: Approaching Zero"
                                   textObject={waste}/>

                        <div className="scale">
                            <img alt=""
                                 src={factory}/>
                        </div>

                        <TextBlock title="A Blossoming Footprint"
                                   textObject={footprint}/>
                    </div>


                    <div className="column">
                        <div className="scale">
                            <img alt=""
                                 className="packaging"
                                 src={packaging}/>
                        </div>

                        <div className="bubblewrap">
                            <div className="statbubble">
                                <div className="info_circle">
                                    <p>
                                        <span>93%</span>
                                        <span>of all waste<br/>diverted from landfill</span>
                                    </p>
                                </div>
                            </div>
                            <div className="statbubble">
                                <div className="info_circle">
                                    <p>
                                        <span>1.5M lbs</span>
                                        <span>of paper &amp; corrugate<br/>diverted from landfill</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <img alt=""
                                 className="building"
                                 src={construction}/>
                        </div>

                        <div>
                            <img alt=""
                                 className="building"
                                 src={building}/>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="layout">
                        {/* <div className="videowrapper"> */}
                        {/* <iframe title="Awards Video"
                                allowFullScreen
                                frameBorder="0"
                                height="664"
                                mozallowfullscreen="true"
                                src="https://player.vimeo.com/video/275303583"
                                webkitallowfullscreen="true"
                                width="800"/> */}


                                 <iframe title="Awards Video"
                                    id="kaltura_player_1530551062" 
                                    src="https://cdnapisec.kaltura.com/p/2169031/sp/216903100/embedIframeJs/uiconf_id/36602371/partner_id/2169031?iframeembed=true&playerId=kaltura_player_1530553596&entry_id=1_pvvgp9eo&flashvars[streamerType]=auto" 
                                    width="768" 
                                    height="655"
                                    allowFullScreen 
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    frameBorder="0"></iframe>
                        {/* </div> */}
                    </div>
                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Awards/Awards.jsx